import React, { Component, Dispatch } from 'react';
import ApiClient from '../../../api/alms-api';
import Translator from '../../../core/i18n';
import { IChangeClass, IChangeClassState } from '../../../models/components/course-change-class';
import { IAction, IAppState, ISelectOption } from '../../../models/action/core';
import * as Actions from '../../../store/actions/coursePage';
import * as announcementActions from '../../../store/actions/announcementPage';
import { Guid } from 'guid-typescript';
import { connect } from 'react-redux';
import { SelectAsync } from '../../input/select/main';
import { Log } from 'ng2-logger';
import queryString from 'querystring';
import { GetActivitiesType } from '../../../models/enums/GetActivityType';
import Select from 'react-select';
import { ValueType } from 'react-select/lib/types';
import { Badge } from 'react-bootstrap';
import ReactGA from 'react-ga4';
import { CourseDefaultViewType } from '../../../models/enums/CourseDefaultViewType';
import { IActivityCard } from '../../../models/components/activity-card';
import { Common } from '../../../core/common';

const T = Translator.create();
let _apiClient: ApiClient;
const _logger = Log.create('ClassSelection');
const token: any = localStorage.getItem('access_token');
let _common: Common;

class ClassSelection extends React.Component<IChangeClass, IChangeClassState> {
    state: IChangeClassState = {
        selectOptions: []
    };

    public courseNavigationn: HTMLDivElement | null = null;

    constructor(props: any) {
        super(props);
        _apiClient = new ApiClient();
        _common = new Common();
    }

    public componentDidUpdate(prevProps: IChangeClass) {
        if (prevProps.coursePageClassId !== this.props.coursePageClassId) {
            let url = window.location.search;
            url = url.replace(prevProps.coursePageClassId!, this.props.coursePageClassId!);
            window.history.pushState(null, '', url);
            this.getOptions();
        }
    }

    public componentDidMount() {
        this.getOptions();
    }

    public getOptions = async () => {
        let requestModel = {
            CourseId: this.props.coursePageActivityId,
            SearchedText: '',
            Skip: 0,
            Take: 9999
        };
        const returnApi = await _apiClient
            .RequestAsync('post', 'api/class/classes', requestModel, token, false, 0)
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                }
                return responseData.json();
            })
            .then((result: any) => {
                let options = [];
                let counter = 0;
                if (result != null && result.length > 0) {
                    const checkResult = result;
                    checkResult.forEach((element: any) => {
                        if (element.label.includes('r_exam_difficulty_')) {
                            element.label = T.t(element.label);
                        } else if (element.label && element.label.includes('r_helpdesk_status_')) {
                            const temp = T.t(element.label);
                            element.label = temp;
                        } else if (element.label === null) {
                            counter += 1;
                            checkResult.splice(element.label, counter);
                        }
                    });
                    options = checkResult;
                    this.state.selectOptions = checkResult;
                    this.setState(this.state);
                } else {
                    this.state.selectOptions = [];
                    this.setState(this.state);
                }
                return options;
            })
            .catch(response => {
                this.setState(this.state);
                return [];
            });

        return returnApi;
    };

    public onChangeSelectedClass = (event: any) => {
        if (event) {
            this.props.dispatch(Actions.getCourseChangeClass(event.value, this.getDatas(event.value)));
        }
    };
    public getDatas = (event: any) => {
        this.triggerActivityList(event);
    };

    public getActivitiesCallback = (classId: string) => {
        let termWeekId =
            this.props.courseDefaultView && this.props.courseDefaultView === CourseDefaultViewType.List ? '-1' : this.props.weekOrUnitId;

        this.props.dispatch(
            Actions.getActivityIdsByWeeks(
                classId,
                '',
                false,
                'getActivityIdsByWeeks',
                'get',
                undefined,
                false,
                this.props.coursePageActivityId ?? ''
            )
        );

        this.props.dispatch(
            Actions.getCourseContentsWeekActivitiesAction(
                classId,
                this.props.coursePageActivityId!,
                false,
                0,
                1000,
                termWeekId === '0' ? '-1' : termWeekId ?? '-1',
                false,
                false,
                null,
                'contentWeekActivities',
                'get',
                false,
                this.props.activityFilters?.sort ?? '-'
            )
        );
    };

    public triggerActivityList = (event: any) => {
        let termWeekId =
            this.props.courseDefaultView && this.props.courseDefaultView === CourseDefaultViewType.List ? '-1' : this.props.weekOrUnitId;

        const param: IActivityCard = {
            actId: '',
            coursePageClassId: event,
            coursePageActivityId: this.props.coursePageActivityId,
            courseContentTermWeeks: this.props.courseContentTermWeeks,
            hasFilter: this.props.activityFilters ? this.props.activityFilters.hasFilter : false,
            activityFilters: this.props.activityFilters,
            GetOnlyPassiveList: this.props.activityFilters?.GetOnlyPassiveList ? this.props.activityFilters?.GetOnlyPassiveList : false,
            weekOrUnitId: termWeekId === '0' ? '-1' : termWeekId,
            courseContentMenuType: this.props.courseContentMenuType,
            sort: this.props.activityFilters?.sort!,
            activeStatus: undefined,
            courseContentWeekActivities: this.props.courseContentWeeksActivities
        };
        this.props.dispatch(
            Actions.SetTriggerGetActivities(
                param,
                this.getActivitiesCallback(event),
                'SetTriggerGetActivities',
                'get',
                this.props.courseDefaultView
            )
        );
    };

    public render() {
        return (
            this.state.selectOptions &&
            this.state.selectOptions.length > 0 && (
                <div className="col-md-3 d-flex justify-content-end p-0">
                    <div className="gap-2" style={{ width: '100%', display: 'grid', gridTemplateColumns: '2fr 3fr' }}>
                        <div className="d-flex justify-content-end align-items-center">
                            <div className="align-self-right mr-2 text-mobile-course">
                                <span style={{ fontSize: '12px', padding: '3px' }} tabIndex={0}>
                                    {T.t('r_total_branch')}
                                </span>
                            </div>
                            <div>
                                {' '}
                                <Badge
                                    pill={true}
                                    variant="light"
                                    style={{ backgroundColor: '#d9dadc', fontWeight: 600, fontSize: '10px' }}
                                    tabIndex={0}
                                >
                                    {this.state.selectOptions && this.state.selectOptions.length > 0 ? this.state.selectOptions.length : 0}
                                </Badge>
                            </div>
                        </div>
                        <div className="react-select-container">
                            <Select
                                id="select_faculty"
                                className={
                                    'react-select' +
                                    (!_common.isArabic(
                                        this.state.selectOptions && this.state.selectOptions[0] ? this.state.selectOptions[0].label : '',
                                        document.body.getAttribute('dir')
                                    )
                                        ? ' arabic-text-direction'
                                        : '')
                                }
                                isMulti={false}
                                classNamePrefix="k365-select"
                                closeMenuOnSelect={true}
                                menuPortalTarget={document.body}
                                menuPosition={'fixed'}
                                options={this.state.selectOptions && this.state.selectOptions ? this.state.selectOptions : []}
                                placeholder={T.t('r_select_branch')}
                                value={
                                    this.state.selectedBranchSelectOptionList != undefined &&
                                    this.state.selectedBranchSelectOptionList != null
                                        ? this.state.selectedBranchSelectOptionList
                                        : this.state.selectOptions[0]
                                }
                                noOptionsMessage={() => T.t('r_select_no_another_Record')}
                                onChange={(options: ValueType<ISelectOption> | ValueType<ISelectOption[]>) => {
                                    ReactGA.event({
                                        category: window.location.host,
                                        action: 'G_DROPDOWN_BRANCH_SELECTED',
                                        label: 'G_DROPDOWN_BRANCH_SELECTED',
                                        nonInteraction: true
                                    });
                                    const list: Array<ISelectOption> = options ? (options as Array<ISelectOption>) : [];
                                    this.state.selectedBranchSelectOptionList = list;
                                    this.setState(this.state);
                                    this.onChangeSelectedClass(list);
                                }}
                            />
                        </div>
                    </div>
                </div>
            )
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IChangeClass): IChangeClass => {
    if (!state) {
        return ownProps;
    }
    const newProps: IChangeClass = Object.assign({}, ownProps, {
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        homePageSelectedTab: state.coursePage.homePageSelectedTab,
        announcements: state.announcement.announcements ? state.announcement.announcements : state.coursePage.announcements,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        activityFilters: state.coursePage.activityFilters,
        courseDefaultView: state.coursePage.coursePageclassInformation?.courseDefaultView,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.coursePage.activityFilters === prev.coursePage.activityFilters &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.coursePageclassInformation?.courseDefaultView === prev.coursePage.coursePageclassInformation?.courseDefaultView &&
        next.coursePage.courseContentMenuType === prev.coursePage.courseContentMenuType &&
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks;
    return ret;
};

const CClassSelection = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(ClassSelection);

export default CClassSelection;
